<script setup>
import { Head, useForm } from '@inertiajs/vue3';
import AuthenticationCard from '@/Components/AuthenticationCard.vue';
import AuthenticationCardLogo from '@/Components/AuthenticationCardLogo.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';

defineProps({
    customers: Array
});

defineOptions({
    layout: null,
});

const form = useForm({
    customer_id: ''
});

const submit = () => {
    form.post(route('customer-choice.choose'), {
        onFinish: () => form.reset('customer_id'),
    });
};
</script>

<template>
    <Head title="Scegli un cliente" />

    <AuthenticationCard>
        <template #logo>
            <AuthenticationCardLogo />
        </template>

        <form @submit.prevent="submit" autocomplete="off">
            <div>
                <select name="customer_id" id="customer_id" v-model="form.customer_id" class="mt-1 block
                    w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500
                    focus:border-indigo-500 sm:text-sm rounded-md">
                    <option value="">Scegli un cliente</option>
                    <option v-for="customer in customers" :value="customer.id" :key="customer.id">
                        {{ customer.name }}
                    </option>
                </select>
            </div>

            <div class="flex justify-center w-full mt-4">
                <PrimaryButton class="ms-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    Procedi
                </PrimaryButton>
            </div>
        </form>
    </AuthenticationCard>
</template>